import React, { useEffect, useState } from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import background from "../assets/background.webp";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Work = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [mounted, setMounted] = useState(false);

  const location = useLocation();
  const project = location.state?.project;

  const { ref, visible: show } = useScrollReveal(0.2);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 80);
    return () => clearTimeout(timer);
  }, []);

  if (!project) {
    return (
      <div className="p-10 text-center text-gray-500">{t("no_project_selected")}</div>
    );
  }
  return (
    <section
      ref={ref}
      style={{ backgroundImage: `url(${background})` }}
      className={`w-full min-h-screen flex items-center max-lg:flex-col justify-center bg-slate-800 bg-cover bg-center px-6 py-20 overflow-hidden transition-all duration-700 ${
        mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
    >
      <button
        onClick={() => navigate(-1)}
        className="self-start mb-6 flex items-center lg:hidden gap-2 text-white hover:text-yellow-500 transition"
      >
        <svg
          viewBox="0 0 24 24"
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M15 18l-6-6 6-6" />
        </svg>
        {t("back")}
      </button>
      <div className="max-w-7xl w-full flex flex-col-reverse lg:flex-row items-center justify-between gap-12">
        {/* LEFT */}
        <div
          className={`
            flex flex-col items-start max-w-xl transition-all duration-1000
            ${show ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-20"}
          `}
        >
          <button
            onClick={() => navigate(-1)}
            className="self-start mb-6 flex max-lg:hidden items-center gap-2 text-white hover:text-yellow-500 transition"
          >
            <svg
              viewBox="0 0 24 24"
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M15 18l-6-6 6-6" />
            </svg>
            {t("back")}
          </button>
          <h1 className="font-['Cormorant_Garamond'] uppercase text-yellow-500 text-[23px] sm:text-[32px] lg:text-[40px] xl:text-[35px] font-light leading-tight tracking-[0.15em]  text-center md:text-left">
            {project.name}
          </h1>

          <p className="mt-6 text-white  text-[16px]">{project.info}</p>
        </div>

        {/* RIGHT */}
        <div
          className={`
            w-full max-w-2xl transition-all duration-1000 delay-200
            ${show && mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"}
          `}
        >
          <img
            src={project.img}
            alt="complex"
            className="w-full h-[500px] max-sm:h-[300px] object-cover shadow-2xl rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
};

export default Work;
